import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../../../common/general/Button';
import Icon from '../../../../../../../common/general/Icon';
import { NSPP_PATIENT } from '../../../../../../../services/i18n/namespaces';

import { InstructionContext } from './InstructionContextProvider';

export function InstructionTab() {
  const { t } = useTranslation();
  const { instructions, editInstruction, canUserAddInstructions } = useContext(InstructionContext);
  return (
    <React.Fragment>
      {t(`${NSPP_PATIENT}:info.instructions.instructions`, { value: instructions?.length || 0 })}
      {canUserAddInstructions && (
        <React.Fragment>
          <Button size="h28" priority="medium" onClick={() => editInstruction()}>
            <Icon>add</Icon>
          </Button>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
